/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component } from "react";
import { EditorState, ContentState } from "draft-js";
import { Tooltip } from "../../../../../revvComponents";

import { IMAGE_URLS } from "../../../../../constants";
import { getContentStateFromRawSectionData } from "../../../../../utils/components";

const { UnmergeImg, MergeImg, DisabledImg } = IMAGE_URLS;

class MergeCellsBtn extends Component {
  state = {};

  // eslint-disable-next-line react/no-deprecated
  componentWillMount = () => {
    document.addEventListener("mousedown", this._handleClick, false);
  };

  componentWillUnmount = () => {
    document.removeEventListener("mousedown", this._handleClick, false);
  };

  _calculateMergedCellsValue = (rowData, cellSelection) => {
    let cellDataIndex = 0;
    let decideShowPopup = false;
    let valuesCounter = 0;
    let { data } = rowData;
    let stepup = 0;
    if (cellSelection) {
      const indices = cellSelection.cols.sort();

      data = data.slice(indices[0], indices[1] + 1);
      // eslint-disable-next-line prefer-destructuring
      stepup = indices[0];
    }

    let cellContentState = EditorState.createEmpty().getCurrentContent();
    data.forEach((col, colId) => {
      const rawCellData = col.data.data;
      let contentState = rawCellData;
      if (!(rawCellData instanceof ContentState)) {
        contentState = getContentStateFromRawSectionData(
          { data: rawCellData },
          this.props.mode,
        );
      }
      const planText = contentState ? contentState.getPlainText() : "";
      if (planText) {
        valuesCounter += 1;
        if (valuesCounter === 1) {
          cellContentState = contentState;
          cellDataIndex = colId + stepup;
        }
      }
    });
    if (valuesCounter > 1) {
      decideShowPopup = true;
      return { cellDataIndex, decideShowPopup, cellContentState };
    }

    return { cellDataIndex, decideShowPopup, cellContentState };
  };

  _handleClick = e => {
    if (
      this.node &&
      !this.node.contains(e.target) &&
      this.props.showMoreTableOptionsDropdown
    ) {
      this.props.toggleDropdown(e, "TableMoreOptions");
      this.props.preventEditorToDeactivate(false);
    }

    if (
      this.node &&
      this.node.contains(e.target) &&
      this.props.showMoreTableOptionsDropdown
    ) {
      // prevent loosing editor focus when style/weight is selected
      this.props.preventEditorToDeactivate(true);
      e.preventDefault();
    }
  };

  _handleClick2 = () => {
    const { className, handleMergeCellsPopup, component, activeComponentMeta } =
      this.props;

    if (className === "unmerge") {
      this.props.mergeCells();
    }
    if (className === "disabled") {
      return;
    }
    const { tableRowId } = activeComponentMeta;
    const { data: tableData } = component.data;

    const mergedCellValue = this._calculateMergedCellsValue(
      tableData[tableRowId],
      activeComponentMeta.cellSelection,
    );

    const { cellDataIndex, decideShowPopup, cellContentState } =
      mergedCellValue;

    handleMergeCellsPopup(
      decideShowPopup,
      component,
      activeComponentMeta,
      className,
      cellDataIndex,
      cellContentState,
    );
  };

  _getBtnImg = () => {
    const { className } = this.props;
    if (className === "disabled") {
      return DisabledImg;
    }
    if (className === "merge") {
      return MergeImg;
    }
    if (className === "unmerge") {
      return UnmergeImg;
    }
    return DisabledImg;
  };

  _getOverlayText = () => {
    const { className } = this.props;
    if (className === "merge") {
      return "Merge";
    }
    if (className === "unmerge") {
      return "Unmerge";
    }
    return "Merge";
  };

  render() {
    const { className, component } = this.props;
    const iconImg = this._getBtnImg();
    const overlayText = this._getOverlayText();
    const {
      attributes: { dataSource },
    } = component.data;

    if (dataSource === "TableApi") return null;
    return (
      <Tooltip
        placement="bottom"
        overlay={overlayText}
        align={{
          offset: [0, 3],
        }}>
        <span
          disabled
          data-test="table-merge-cell-btn"
          className={`revvtabletoolbar-btn btn-negative btn-${className}`}
          onMouseDown={() => {
            this._handleClick();
            this._handleClick2();
          }}
          role="button"
          tabIndex={0}>
          <img className="" src={iconImg} alt="Merge Cells" />
        </span>
      </Tooltip>
    );
  }
}

export default MergeCellsBtn;
